import { staffService } from '@/modules/staff/services/staffService';

const state = {
    staffSlots: {
        used: 0,
        quota: {
            total: 0,
            bundled: 0,
            purchased: 0,
            unlimited: false,
        },
    },
};

const mutations = {
    setStaffSlots(state, slotsData) {
        state.staffSlots = {
            used: slotsData?.used || 0,
            quota: {
                total: slotsData?.quota?.total || 0,
                bundled: slotsData?.quota?.bundled,
                purchased: slotsData?.quota?.purchased,
                unlimited: slotsData?.quota?.unlimited || false,
            },
        };
    },
};

const actions = {
    // Staff slots actions
    async loadStaffSlots({ commit }, businessUid) {
        try {
            const slotsData = await staffService.fetchStaffSlots(businessUid);
            commit('setStaffSlots', slotsData);
        } catch (e) {
            console.error('Error loading staff slots:', e);
            throw e;
        }
    },
};

const getters = {
    staffSlots: (state) => state.staffSlots,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
